import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../components/Button";
import { InfoBox, SummaryCard } from "../../components/StyledComponent";
import { BreakLine, Card, CheckPoint, ConnectingCheckPoints, Loader } from "@egovernments/digit-ui-react-components";
import TLCaption from "../../../../../../../templates/ApplicationDetails/components/TLCaption";

const Step6 = ({ formData, handleTabChange }) => {
  const { t } = useTranslation();
  const { handleSubmit, control, setValue, watch, reset } = useForm({});
  const tenantId = Digit.ULBService.getStateId();
  const onSubmit = (data) => {
    handleTabChange(4, data);
  };
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: formData?.applicationNo,
    moduleCode: formData?.businessService,
  });
  function OpenImage(imageSource, index, thumbnailsToShow) {
    window.open(thumbnailsToShow?.fullImage?.[0], "_blank");
  }
  const getTimelineCaptions = (checkpoint) => {
    if (checkpoint.state === "OPEN" || (checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/"))) {
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate(applicationData?.auditDetails?.createdTime),
        source: applicationData?.channel || "",
      };
      return <TLCaption data={caption} />;
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      const caption = {
        date: checkpoint?.auditDetails?.lastModified,
        name: checkpoint?.assignes?.[0]?.name,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
        comment: t(checkpoint?.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint?.thumbnailsToShow,
      };
      return <TLCaption data={caption} OpenImage={OpenImage} />;
    } else {
      const caption = {
        date: Digit.DateUtils?.ConvertTimestampToDate(applicationData?.auditDetails?.lastModifiedTime),
        name: checkpoint?.assignes?.[0]?.name,
        wfComment: checkpoint?.wfComment,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
      };
      return <TLCaption data={caption} />;
    }
  };
  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Application History</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            {workflowDetails?.data?.timeline?.length > 0 && (
              <React.Fragment>
                <BreakLine />
                {workflowDetails?.isLoading && <Loader />}
                {!workflowDetails?.isLoading && (
                  <div>
                    {workflowDetails?.data?.timeline && workflowDetails?.data?.timeline?.length === 1 ? (
                      <Card style={{ backgroundColor: "aliceblue", borderRadius: "20px" }}>
                        <CheckPoint
                          isCompleted={true}
                          label={t(`${workflowDetails?.data?.timeline[0]?.state}`)}
                          customChild={getTimelineCaptions(workflowDetails?.data?.timeline[0])}
                        />
                      </Card>
                    ) : (
                      <ConnectingCheckPoints>
                        {workflowDetails?.data?.timeline &&
                          workflowDetails?.data?.timeline.map((checkpoint, index, arr) => {
                            return (
                              <React.Fragment key={index}>
                                <Card style={{ backgroundColor: "aliceblue", borderRadius: "20px" }}>
                                  <CheckPoint
                                    keyValue={index}
                                    isCompleted={index === 0}
                                    info={checkpoint.comment}
                                    label={t(`${checkpoint?.performedAction === "REOPEN" ? checkpoint?.performedAction : checkpoint?.["status"]}`)}
                                    customChild={getTimelineCaptions(checkpoint)}
                                  />
                                </Card>
                              </React.Fragment>
                            );
                          })}
                      </ConnectingCheckPoints>
                    )}
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
        </SummaryCard>

        <div className="footerContainer">
          <div className="buttonWrapper">
            {/* <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Prev"
                            sx={{ backgroundColor: '#CCC' }}
                            onClick={() => handleTabChange(3)}
                        /> */}
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      </form>
    </section>
  );
};
export default Step6;
